<div class="fixedCostContainer">
  <div class="fixedCostToggle">
    <div
      class="fixedCostToggleButton"
      (click)="userToggleFxActive(true,hasAdjFx)"
      [ngClass]="{ fixedCostToggleButtonActive: isFxActive,disabled:!hasAdjFx }"
    >
      Adj FX
    </div>
    <div
      class="fixedCostToggleButton"
      (click)="userToggleFxActive(false,hasOffFx)"
      [ngClass]="{ fixedCostToggleButtonActive: !isFxActive,disabled:!hasOffFx }"
    >
      Off FX
    </div>
  </div>

  <div class="mainSectionContainer">
    <div class="mainSectionColNames">
      <div
        *ngFor="let name of data?.graph?.data?.[(navState?.bu) || 0]?.data?.[isFxActive ? 0 : 1]?.graph?.rowNames; let index = index; trackBy: trackByIndex"
      >
        {{ name }}
      </div>
    </div>

    <div
      *ngFor="let item of data?.graph?.data?.[(navState?.bu) || 0]?.data?.[isFxActive ? 0 : 1]?.graph?.data; let index = index; trackBy: trackByIndex"
    >
      <div
        class="totalRow"
        *ngIf="index === 0"
        [ngClass]="{ activeRow: activeRow === index }"
        (click)="userSetActiveBox(index)"
      >
        <img src="assets/icons/fixedCostPrimaryBox.svg" />
        <img
          src="assets/icons/{{ item?.iconName }}.svg"
          class="iclIcon"
        />
        <img
          src="assets/icons/fixedCostPrimaryBoxSpeed.svg"
          class="bottomRightSpeed"
        />
        <img
          src="assets/icons/fixedCostPrimaryBoxTitleContainer.svg"
          class="titleContainerVector"
        />
        <span class="titleContainerText">
          {{ item?.colName }}
        </span>
        <div class="rowValues">
          <div
            *ngFor="let value of item?.data?.[selectedSliderValue]; trackBy: trackByIndex"
          >
            {{ value }}
          </div>
        </div>
      </div>

      <div
        class="secondaryRow"
        [ngClass]="{ activeRow: activeRow === index }"
        *ngIf="index !== 0"
        (click)="userSetActiveBox(index)"
      >
        <img src="assets/icons/fixedCostSecondaryBox.svg" />
        <img src="assets/icons/{{ item.iconName }}.svg" class="rowIcon" />
        <img
          src="assets/icons/fixedCostSecondaryBoxSpeed.svg"
          class="topLeftSpeed"
        />
        <span class="secondaryTitleContainerText"> {{ item.colName }} </span>

        <div class="rowValues">
          <div *ngFor="let value of item?.data?.[selectedSliderValue]; trackBy: trackByIndex">{{ value }}</div>
        </div>
      </div>
    </div>
  </div>

  <app-battery-graph
    [isMainGraph]="!!data?.graph?.isMainGraph"
    [navState]="navState"
    [isLoading]="isLoading"
    [columnIndex]="selectedSliderValue"
    [batteries]="data?.graph?.data?.[(navState?.bu) || 0]?.data?.[isFxActive ? 0 : 1]?.battery?.[selectedSliderValue]"
    [currentSbuTitle]="data?.graph?.data?.[(navState?.bu) || 0]?.title"
    type="fixed cost"
  >
  </app-battery-graph>
  <div class="slider-container">
    <echarts
    [options]="chartOptions"
    (chartInit)="onChartInit($event)"
    [autoResize]="false"
    class="chart-container">
    </echarts>
  </div>
</div>
